module.exports = __webpack_public_path__ + "static/media/UniNeueBold.2861e030.woff2";